import React, { useState } from 'react';
import styles from './RoleManagement.module.css';

const CreateRoleModal = ({ show, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({
        roleName: '',
        description: ''
    });

    if (!show) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await onSubmit(formData);
        if (result.success) {
            setFormData({ roleName: '', description: '' });
            onClose();
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Create New Role</h2>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.modalBody}>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Role Name </label>
                            <input
                                type="text"
                                className={styles.input}
                                required
                                value={formData.roleName}
                                onChange={(e) => setFormData({ ...formData, roleName: e.target.value })}
                                placeholder="Enter role name"
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Description</label>
                            <textarea
                                className={styles.textarea}
                                rows="3"
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                placeholder="Enter role description"
                            />
                        </div>
                    </div>
                    <div className={styles.modalFooter}>
                        <button type="button" className={styles.cancelButton} onClick={onClose}>Cancel</button>
                        <button type="submit" className={styles.submitButton}>Create Role</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateRoleModal;